"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BCID_WITH_ALT_ID_EXPERIMENT_TYPE = void 0;
exports.BCID_WITH_ALT_ID_EXPERIMENT_TYPE = 'bcidWithAltId';
exports.default = {
    BCID_WITH_ALT_ID_EXPERIMENT_TYPE: exports.BCID_WITH_ALT_ID_EXPERIMENT_TYPE
};
